/** 画面の遅延ロードとメニューの先読みで同じ import を共有する。API 取得は発火しない。 */
export const pageLoaders = {
  DashboardPage: () => import('@/pages/DashboardPage'),
  CasePatrolPage: () => import('@/pages/CasePatrolPage'),
  ClientsPage: () => import('@/pages/ClientsPage'),
  ClientTasksPage: () => import('@/pages/ClientTasksPage'),
  CasesPage: () => import('@/pages/CasesPage'),
  HouseholdBudgetsPage: () => import('@/pages/HouseholdBudgetsPage'),
  BankImportPreviewPage: () => import('@/pages/BankImportPreviewPage'),
  BankImportHistoryPage: () => import('@/pages/BankImportHistoryPage'),
  BankImportBatchDetailPage: () => import('@/pages/BankImportBatchDetailPage'),
  PaymentMatchQueuePage: () => import('@/pages/PaymentMatchQueuePage'),
  DelinquencyPage: () => import('@/pages/DelinquencyPage'),
  VirtualAccountsPage: () => import('@/pages/VirtualAccountsPage'),
  ReceivingAccountsPage: () => import('@/pages/ReceivingAccountsPage'),
  CollectionsPage: () => import('@/pages/CollectionsPage'),
  VaultPage: () => import('@/pages/VaultPage'),
  AdminPage: () => import('@/pages/AdminPage'),
  ClientGroupsPage: () => import('@/pages/ClientGroupsPage'),
  CalendarPage: () => import('@/pages/CalendarPage'),
  LoginPage: () => import('@/pages/LoginPage'),
  SsoCallbackPage: () => import('@/pages/SsoCallbackPage'),
  ReportsPage: () => import('@/pages/ReportsPage'),
  TemplatesPage: () => import('@/pages/TemplatesPage'),
  DocMasterPage: () => import('@/pages/DocMasterPage'),
  CreditorMasterPage: () => import('@/pages/CreditorMasterPage'),
  MessagesPage: () => import('@/pages/MessagesPage'),
  MessageWorkspacePage: () => import('@/pages/MessageWorkspacePage'),
  OrgSettingsPage: () => import('@/pages/OrgSettingsPage'),
  PreferencesPage: () => import('@/pages/PreferencesPage'),
  AiConnectionsPage: () => import('@/pages/AiConnectionsPage'),
  BugReportPage: () => import('@/pages/BugReportPage'),
  RequestStatusPage: () => import('@/pages/RequestStatusPage'),
  HelpPage: () => import('@/pages/HelpPage'),
  PortalPage: () => import('@/pages/portal/PortalPage'),
  PortalBudgetPage: () => import('@/pages/portal/PortalBudgetPage'),
  ShortLinkRedirectPage: () => import('@/pages/portal/ShortLinkRedirectPage'),
  PlatformPage: () => import('@/pages/PlatformPage'),
  ChatworkPage: () => import('@/pages/ChatworkPage'),
  LinePage: () => import('@/pages/LinePage'),
};

const navigationPages: Record<string, keyof typeof pageLoaders> = {
  '/': 'DashboardPage',
  '/clients': 'ClientsPage',
  '/cases': 'CasesPage',
  '/client-tasks': 'ClientTasksPage',
  '/collections': 'CollectionsPage',
  '/vault': 'VaultPage',
  '/calendar': 'CalendarPage',
  '/reports': 'ReportsPage',
  '/household-budgets': 'HouseholdBudgetsPage',
  '/client-groups': 'ClientGroupsPage',
  '/templates': 'TemplatesPage',
  '/doc-master': 'DocMasterPage',
  '/creditor-master': 'CreditorMasterPage',
  '/messages': 'MessagesPage',
  '/message-workspace': 'MessageWorkspacePage',
  '/settings/org': 'OrgSettingsPage',
  '/preferences': 'PreferencesPage',
  '/ai-connections': 'AiConnectionsPage',
  '/bug-report': 'BugReportPage',
  '/request-status': 'RequestStatusPage',
  '/help': 'HelpPage',
  '/admin/users': 'AdminPage',
  '/admin/audit': 'AdminPage',
  '/platform': 'PlatformPage',
  '/chatwork': 'ChatworkPage',
  '/line': 'LinePage',
  '/payments/imports': 'BankImportPreviewPage',
  '/payments/imports/history': 'BankImportHistoryPage',
  '/payments/matches': 'PaymentMatchQueuePage',
  '/payments/delinquency': 'DelinquencyPage',
  '/payments/virtual-accounts': 'VirtualAccountsPage',
  '/payments/receiving-accounts': 'ReceivingAccountsPage',
};

/** 利用者が選ぼうとしている1画面だけ先読みする。失敗しても通常の遷移で再試行する。 */
export function preloadNavigationPage(path: string): void {
  const page = navigationPages[path];
  if (page) void pageLoaders[page]().catch(() => {});
}
